import Toastr from "../../itrust_common/components/Toastr"

const DEFAULT_STATE = {
  countries: [],
  country: {},
  meta: { pagination: {} },
  saving: false,
  loading: false
}
let changes = null
export default function manageCountriesReducer(state = DEFAULT_STATE, action) {
  const response = action.payload && (action.payload.data || action.payload.response)
  switch (action.type) {
    case 'COUNTRIES_LOAD_PENDING':
      return { ...state, loading: true };

    case 'COUNTRY_CREATE_PENDING':
    case 'COUNTRY_UPDATE_PENDING':
      return { ...state, saving: true };

    case 'COUNTRIES_LOAD_REJECTED':
    case 'COUNTRY_CREATE_REJECTED':
    case 'COUNTRY_LOAD_REJECTED':
    case 'COUNTRY_UPDATE_REJECTED':
      Toastr.handleShow(response.data.success, response.data.error, response.data.status_code)
      changes = {
        saving: false,
        loading: false
      }
      return { ...state, ...changes };

    case 'COUNTRIES_LOAD_FULFILLED':
      changes = {
        countries: response.global_pricings,
        meta: response.meta,
        loading: false
      }
      return { ...state, ...changes }

    case 'COUNTRY_CREATE_FULFILLED':
      changes = {
        countries: [...state.countries, response.global_pricing],
        saving: false
      };
      return { ...state, ...changes };

    case 'COUNTRY_LOAD_FULFILLED':
      changes = {
        country: response.global_pricing,
      };
      return { ...state, ...changes };

    case 'COUNTRY_UPDATE_FULFILLED':
      Toastr.handleShow(true, response.meta.message, 201)
      changes = {
        country: response.global_pricing,
        saving: false
      };
      return { ...state, ...changes };

    case 'COUNTRY_EDIT':
      changes = {
        editing: action.payload
      };
      return { ...state, ...changes };

    case 'COUNTRY_EDIT_CANCEL':
      changes = {
        editing: false,
        country: {}
      };
      return { ...state, ...changes };

    default:
      return state
  }
}